import { useHasPermission } from '@contexts/permissions-provider';
import * as React from 'react';

import { CustomerCareTile } from './customer-care-tile/CustomerCareTile';
import styles from './ForYou.module.css';

const ForYou = React.memo((): React.ReactElement | null => {
  const hasAccess = useHasPermission('HelpBasic_View_Any');

  if (!hasAccess) return null;

  return (
    <section
      className={styles.forYou}
      data-testid="for-you"
      aria-labelledby="for-you-title"
    >
      <h2 className="heading-02" id="for-you-title">
        For you
      </h2>
      <CustomerCareTile />
    </section>
  );
});

ForYou.displayName = 'ForYou';

export { ForYou };
